module.exports = __webpack_public_path__ + "img/tx.0571856e.png";